export default "__VITE_ASSET__DohmuoTr__"